// FieldConfig.js

export class FieldConfig {
  constructor(key, label, placeholder = "", priority = 1, type = 'input', visibility = '', IsVisible = false,
    //  PagePermission = 'disable'
    //  ,
    place = '', value = "") {
    this.key = key;
    this.label = label;
    this.placeholder = placeholder;
    this.priority = priority;
    this.type = type;
    this.visibility = visibility;
    this.IsVisible = IsVisible;
    // this.PagePermission = PagePermission;
    this.place = place;
    this.value = value;

  }

  // Method to update visibility based on API response
  setVisibility(isVisible) {
    this.isVisible = isVisible;
  }
}




export const StonePopUpFields = [

  new FieldConfig("StoneName", "Stone Name", "", 1, "inputselect", "ReadWrite", true, "top"),
  new FieldConfig("StoneColor", "Color", "", 1, "inputselect", "ReadWrite", true, "top"),

  new FieldConfig("StoneShape", "Shape", "", 1, "inputselect", "ReadWrite", true, "top"),
  new FieldConfig("StoneSize", "Size", "", 1, "inputselect", "ReadWrite", true, "top"),

  new FieldConfig("StoneWeight", "Weight", "", 1, "inputdecimal", "ReadWrite", true, "top"),
  new FieldConfig("StonePieces", "Pieces", "", 1, "inputdecimal", "ReadWrite", true, "top"),

  new FieldConfig("StoneRatePiece", "Rate/Piece", "", 1, "inputdecimal", "ReadWrite", true, "top"),
  new FieldConfig("StoneRateKarate", "Rate/Gram", "", 1, "inputdecimal", "ReadWrite", true, "top"),
  new FieldConfig("StoneAmount", "Amount", "", 1, "inputdecimal", "ReadWrite", true, "top"),
  new FieldConfig("Description", "Description", "", 1, "inputtext", "ReadWrite", true, "top"),
  new FieldConfig("ActionPlus", "Action", "", 1, "Icon", "ReadWrite", true, "top"),
 

];
